__turbopack_context__.v({
  "body": "booking-module__XrNC1a__body",
  "border": "booking-module__XrNC1a__border",
  "pricing": "booking-module__XrNC1a__pricing",
  "quantityButton": "booking-module__XrNC1a__quantityButton",
  "seasonCard": "booking-module__XrNC1a__seasonCard",
  "sectionTitle2": "booking-module__XrNC1a__sectionTitle2",
  "subVenueCard": "booking-module__XrNC1a__subVenueCard",
  "subVenueTiming": "booking-module__XrNC1a__subVenueTiming",
  "ticket": "booking-module__XrNC1a__ticket",
  "title": "booking-module__XrNC1a__title",
  "venueSelection": "booking-module__XrNC1a__venueSelection",
});
